<div class="modal-header">
    <h4 class="modal-title"><strong>Estrategia {{ data.strategy.name }} - Artes fuente</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        
        <mat-divider></mat-divider>
        
            <div class="row borderMdl">
                <div class="col mb-0 mt-3">

                    <div *ngIf="mostrarSeleccionSku" class="table-responsive text-nowrap">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Archivo</th>
                                    <th>Producto</th>
                                    <th class="text-center">Páginas</th>
                                    <th class="text-center">Validación</th>
                                    <th></th> 
                                </tr>
                            </thead>
                            <tbody class="table-border-bottom-0">
                                <tr *ngFor="let sku of skus">
                                    <td>{{sku.nombre_archivo}}</td>
                                    <td>{{sku.family.length > 30 ? sku.family.slice(0,35) + "..." : sku.family}}</td>
                                    <td class="text-center">{{sku.paginas}} pág.</td>
                                    <td class="text-center">
                                        <span *ngIf="sku.file_respuesta_report == null && sku.pagesMedidasDif == 0" class="d-inline-flex align-items-center gap-1 text-muted">
                                            <span>Validando...</span>
                                            <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="18" [strokeWidth]="3"></mat-progress-spinner>
                                        </span>
                                        <button *ngIf="(sku.file_respuesta_report != null && sku.bitValido == 0) || (sku.pagesMedidasDif == 1)" mat-flat-button class="btn-pill btn-warning d-inline-flex align-items-center gap-1">
                                            <mat-icon class="mat-icon-sm me-1">close</mat-icon>
                                            <span>No válido</span>
                                        </button>
                                        <button *ngIf="sku.file_respuesta_report != null && sku.bitValido == 1" mat-flat-button class="btn-pill btn-success d-inline-flex align-items-center gap-1">
                                            <mat-icon class="mat-icon-sm me-1">check</mat-icon>
                                            <span>Válido</span>
                                        </button>
                                    </td>
                                    <td class="text-center">
                                        <button mat-flat-button class="btn-pill me-2 d-inline-flex align-items-center" color="primary" (click)="openDialogArte(sku.archivo)">Ver arte <mat-icon class="ms-1">visibility</mat-icon></button>
                                        <button mat-flat-button class="btn-pill me-2 d-inline-flex align-items-center" color="primary" (click)="openDialogHistorial(sku.id_sku,sku.ancho,sku.alto,sku.id_family,sku.family)">Historial <mat-icon class="ms-1">history</mat-icon></button>
                                        <button *ngIf="sku.file_respuesta_report != null" mat-flat-button class="btn-pill btn-slate d-inline-flex align-items-center" (click)="openDialogArte(sku.file_respuesta_report)">Reporte <mat-icon class="ms-1">article</mat-icon></button>
                                        <button mat-icon-button color="warn"  (click)="deleteArtes(sku.id_family)" class="ms-2">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="skus.length == 0" >
                                    <td colspan="5" class="text-center">
                                        No se han añadido productos
                                    </td>
                                </tr>
                            </tbody>
                                
                        </table>
                    </div>
                    

                </div>
            </div>
    </div>
    <div class="modal-footer mt-3 ms-5 me-5" [ngClass]="{'d-flex justify-content-between': !mostrarSeleccionSku}">
        <button mat-flat-button class="bg-info text-white align-items-center me-3" (click)="openDialogArtNewProduct()">
            <label style="cursor: pointer !important">Cargar arte </label>
            <mat-icon class="ms-1">add</mat-icon>
        </button>
        <button  mat-flat-button class="bg-secondary text-white d-flex align-items-center" mat-dialog-close [style.cursor]="'pointer'">
            <label [style.cursor]="'pointer'">Cerrar</label>
        </button>
    </div>

</mat-dialog-content>